// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://api.fontshare.com/v2/css?f[]=satoshi@400,500,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Instrument+Sans:ital,wght@0,400..700;1,400..700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landingPageLeft {
  margin-left: 15%;
  margin-top: 14%;
  width: 50%;
}
.billionUserContainer {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #000000;
  border-radius: 100px;
  background-color: #18181a;
  padding: 10.24px 13.51px 9.76px 8px;
}
.billionUserContainer2 {
  display: flex;
  align-items: center;
  gap: 18px;
}
.userImgContainer {
  display: flex;
  align-items: center;
}
.userImg {
  height: 28px;
  width: 28px;
  margin-left: -8px;
}
.userImg2 {
  height: 28px;
  width: 28px;
  margin-left: 0px;
}
.billionUserText {
  color: #fff;
  font-family: "Instrument Sans", sans-serif;
  font-size: 16px;
  font-weight: 450;
  line-height: 24px;
  white-space: nowrap;
}

.itsTimeToContainer {
  display: flex;
  align-items: center;
  margin-top: 1vh;
  font-family: "Bebas Neue", sans-serif;
  font-size: 71.5px;
  gap: 1.8vw;
}
.itsTimeToText {
  color: white;
  white-space: nowrap;
}
.unite {
  position: relative;
  width: 110%;
  height: 90px;
  overflow: hidden;
}
.uniteMotion {
  position: absolute;
  line-height: inherit;
  background: linear-gradient(100deg, #5aaf9a, #264940);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.longTextContainer {
  margin-top: 1.5vh;
  width: 100%;
}
.longText {
  color: #c9c9c9;
  font-family: "Satoshi", sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
}
.amalgamateWord {
  display: inline-block;
  vertical-align: middle;
  height: auto;
  width: auto;
}
.donationLastContainer {
  display: flex;
  align-items: center;
  gap: 58px;
  margin-top: 5vh;
}
.donationAppAvailableFor {
  /* margin-top: 3.2vh; */
  display: inline-flex;
  align-items: center;
  gap: 0.5vw;
  justify-content: center;
}
.appAvailableForText {
  font-family: "Instrument Sans", sans-serif;
  font-size: 16px;
  color: white;
  white-space: nowrap;
  font-weight: 500;
}
.iconContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0e0e10;
  border: 1px solid rgba(134, 134, 134, 0.16);
  border-radius: 100px;
}
.iconContainer2 {
  display: inline-flex;
  align-items: center;
  gap: 0.521vw;
  padding: 0.741vh 0.625vw;
}
.smallIcon {
  height: 28px;
  width: 28px;
}

.verticalLine {
  width: 1px;
  height: 20px;
  background-color: rgba(134, 134, 134, 0.16);
}

@media screen and (max-width: 1440px) {
  .billionUserContainer2 {
    gap: 16px;
  }
  .userImg {
    height: 25px;
    width: 25px;
    margin-left: -10px;
  }
  .userImg2 {
    height: 25px;
    width: 25px;
    margin-left: 0px;
  }
  .billionUserText {
    font-size: 15px;
    font-weight: 400;
  }
  .itsTimeToContainer {
    font-size: 60px;
  }
  .unite {
    /* width: 250px; */
    height: 80px;
  }
  .longText {
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
  }
  .amalgamateWord {
    height: 10px;
  }
  .appAvailableForText {
    font-size: 14px;
  }
  .smallIcon {
    height: 24px;
    width: 24px;
  }
}
@media screen and (max-width: 1240px) {
  .billionUserContainer2 {
    gap: 14px;
  }
}

@media screen and (max-width: 1024px) {
  .billionUserContainer {
    padding: 8px 13.51px 8px 8px;
  }
  .billionUserContainer2 {
    gap: 12px;
  }
  .userImg {
    height: 18.5px;
    width: 18.5px;
    margin-left: -10px;
  }
  .userImg2 {
    height: 18.5px;
    width: 18.5px;
    margin-left: 0px;
  }
  .billionUserText {
    font-size: 12px;
    font-weight: 400;
  }
  .itsTimeToContainer {
    font-size: 45px;
  }
  .unite {
    /* width: 230px; */
    height: 58px;
  }
  .longText {
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
  }
  .amalgamateWord {
    height: 8px;
  }
  .appAvailableForText {
    font-size: 12px;
  }
  .smallIcon {
    height: 20px;
    width: 20px;
  }
}

@media screen and (max-width: 768px) {
  .landingPageLeft {
    display: none !important;
    visibility: hidden !important;
    height: 0 !important;
    width: 0 !important;
    overflow: hidden !important;
    margin: 0 !important;
    padding: 0 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Donation/LandingPage/LandingPageLeft.css"],"names":[],"mappings":"AAIA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,0CAA0C;EAC1C,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;EAC3C,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,6BAA6B;IAC7B,oBAAoB;IACpB,mBAAmB;IACnB,2BAA2B;IAC3B,oBAAoB;IACpB,qBAAqB;EACvB;AACF","sourcesContent":["@import url(\"https://api.fontshare.com/v2/css?f[]=satoshi@400,500,700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Instrument+Sans:ital,wght@0,400..700;1,400..700&display=swap\");\n\n.landingPageLeft {\n  margin-left: 15%;\n  margin-top: 14%;\n  width: 50%;\n}\n.billionUserContainer {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #000000;\n  border-radius: 100px;\n  background-color: #18181a;\n  padding: 10.24px 13.51px 9.76px 8px;\n}\n.billionUserContainer2 {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n}\n.userImgContainer {\n  display: flex;\n  align-items: center;\n}\n.userImg {\n  height: 28px;\n  width: 28px;\n  margin-left: -8px;\n}\n.userImg2 {\n  height: 28px;\n  width: 28px;\n  margin-left: 0px;\n}\n.billionUserText {\n  color: #fff;\n  font-family: \"Instrument Sans\", sans-serif;\n  font-size: 16px;\n  font-weight: 450;\n  line-height: 24px;\n  white-space: nowrap;\n}\n\n.itsTimeToContainer {\n  display: flex;\n  align-items: center;\n  margin-top: 1vh;\n  font-family: \"Bebas Neue\", sans-serif;\n  font-size: 71.5px;\n  gap: 1.8vw;\n}\n.itsTimeToText {\n  color: white;\n  white-space: nowrap;\n}\n.unite {\n  position: relative;\n  width: 110%;\n  height: 90px;\n  overflow: hidden;\n}\n.uniteMotion {\n  position: absolute;\n  line-height: inherit;\n  background: linear-gradient(100deg, #5aaf9a, #264940);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.longTextContainer {\n  margin-top: 1.5vh;\n  width: 100%;\n}\n.longText {\n  color: #c9c9c9;\n  font-family: \"Satoshi\", sans-serif;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 22px;\n}\n.amalgamateWord {\n  display: inline-block;\n  vertical-align: middle;\n  height: auto;\n  width: auto;\n}\n.donationLastContainer {\n  display: flex;\n  align-items: center;\n  gap: 58px;\n  margin-top: 5vh;\n}\n.donationAppAvailableFor {\n  /* margin-top: 3.2vh; */\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5vw;\n  justify-content: center;\n}\n.appAvailableForText {\n  font-family: \"Instrument Sans\", sans-serif;\n  font-size: 16px;\n  color: white;\n  white-space: nowrap;\n  font-weight: 500;\n}\n.iconContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #0e0e10;\n  border: 1px solid rgba(134, 134, 134, 0.16);\n  border-radius: 100px;\n}\n.iconContainer2 {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.521vw;\n  padding: 0.741vh 0.625vw;\n}\n.smallIcon {\n  height: 28px;\n  width: 28px;\n}\n\n.verticalLine {\n  width: 1px;\n  height: 20px;\n  background-color: rgba(134, 134, 134, 0.16);\n}\n\n@media screen and (max-width: 1440px) {\n  .billionUserContainer2 {\n    gap: 16px;\n  }\n  .userImg {\n    height: 25px;\n    width: 25px;\n    margin-left: -10px;\n  }\n  .userImg2 {\n    height: 25px;\n    width: 25px;\n    margin-left: 0px;\n  }\n  .billionUserText {\n    font-size: 15px;\n    font-weight: 400;\n  }\n  .itsTimeToContainer {\n    font-size: 60px;\n  }\n  .unite {\n    /* width: 250px; */\n    height: 80px;\n  }\n  .longText {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 18px;\n  }\n  .amalgamateWord {\n    height: 10px;\n  }\n  .appAvailableForText {\n    font-size: 14px;\n  }\n  .smallIcon {\n    height: 24px;\n    width: 24px;\n  }\n}\n@media screen and (max-width: 1240px) {\n  .billionUserContainer2 {\n    gap: 14px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .billionUserContainer {\n    padding: 8px 13.51px 8px 8px;\n  }\n  .billionUserContainer2 {\n    gap: 12px;\n  }\n  .userImg {\n    height: 18.5px;\n    width: 18.5px;\n    margin-left: -10px;\n  }\n  .userImg2 {\n    height: 18.5px;\n    width: 18.5px;\n    margin-left: 0px;\n  }\n  .billionUserText {\n    font-size: 12px;\n    font-weight: 400;\n  }\n  .itsTimeToContainer {\n    font-size: 45px;\n  }\n  .unite {\n    /* width: 230px; */\n    height: 58px;\n  }\n  .longText {\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 16px;\n  }\n  .amalgamateWord {\n    height: 8px;\n  }\n  .appAvailableForText {\n    font-size: 12px;\n  }\n  .smallIcon {\n    height: 20px;\n    width: 20px;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .landingPageLeft {\n    display: none !important;\n    visibility: hidden !important;\n    height: 0 !important;\n    width: 0 !important;\n    overflow: hidden !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
